<template>
<div>
	<div class="row">
        <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-xs-12">
		    <card class="card" :title="isNew ? 'Add client' : 'Edit client'">
                <loader :loading="loading_client">
					<form @submit.prevent v-if="!loading_client">
						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="First name"
										placeholder="First name"
										:class="{'has-error':$v.client.first_name.$error}"
										v-model="$v.client.first_name.$model">
								</fg-input>
							</div>
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Last name"
										placeholder="Last name"
										:class="{'has-error':$v.client.last_name.$error}"
										v-model="$v.client.last_name.$model">
								</fg-input>
							</div>
						</div>

						<div class="row">
							
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Address"
										placeholder="Address"
										:class="{'has-error':$v.client.address.$error}"
										v-model="$v.client.address.$model">
								</fg-input>
							</div>
                            <div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Telephone"
										placeholder="Telephone"
										:class="{'has-error':$v.client.telephone_number.$error}"
										v-model="$v.client.telephone_number.$model">
								</fg-input>
							</div>
						</div>

						<template name="footer">
							<div class="row mt-4">
								<div class="col-4 text-left">
									<router-link to="/clients">
										<p-button  type="link" round>
										Back
										</p-button>
									</router-link>
								</div>
								<div class="col-8 text-right">
									<p-button v-if="isNew || (!isNew && isModified)" :loading="loading_save || $v.client.$pending" type="success"
											round
											@click.native.prevent="saveClient">
									Save
									</p-button>
									<p-button v-if="!isNew && !isModified" :loading="loading_delete" type="danger"
											round
											@click.native.prevent="deleteClient">
									Delete
									</p-button>
								</div>
							</div>
						</template>
			
		        	</form>
				</loader>
		  	    
		    </card>
	    </div>

	</div>

</div>
</template>
<script>

import {required,numeric} from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect'

export default {
	components:{
		Multiselect
	},
  	data(){
		return{
			client:{},
			helpers:[],
			departments:[],
			departments_delete:[],
			loading_client:false,
			loading_save:false,
			loading_delete:false,
		}
  	},
  	validations:{
		client:{
            first_name:{required},
            last_name:{},
            address:{required},
			telephone_number:{}
	  	}
  	},
	computed:{
		isNew(){
			return this.$route.params.id_client==='new'; 
		},
		isModified(){
			return this.$v.client.$anyDirty;
		},
		idClient(){
			return this.$route.params.id_client;
		}
	},
  	methods:{

	/*client*/
	async loadClient(){
	  if(this.isNew){
		let result = {
		  data:{
			id_client:null,
            first_name:null,
            last_name:null,
            address:null,
			telephone_number:null
		  }
		}
		this.client = result.data;
	  }
	  else{
		let result = await this.$api.get('client/'+this.idClient);
		this.client = result.data;
	  }
	},
	async saveClient(){
		this.$v.client.$touch();
		this.loading_save = true;

		if(!this.$v.client.$invalid){
			if(this.isNew){
				let result = await this.$api.post('client',this.client);
				this.client.id_client = result.data.id_client;
			}
			else{
				let result = await this.$api.put('client/'+this.idClient,this.client);
			}

			this.$toast.success({
				message:this.isNew ? 'client added' : 'client edited',
				icon: "ti-check"
			});
			if(this.isNew){
				this.$router.push({path:'/clients/'+this.client.id_client});
			}
			this.$v.client.$reset();
		}
		else{
			this.$toast.error({
				message:'Some fields must be completed',
				icon: "ti-face-sad"
			});			
		}
		
		this.loading_save = false;
	},
	async deleteClient(){
		try{
			this.loading_delete = true;
			await this.$api.delete('client/'+this.idClient);
			this.loading_delete = false;
			this.$toast.error({
				message:'client deleted',
				icon: "ti-check"
			});
			this.$router.push({path:'/clients'});
		}
		catch(error){
			this.loading_delete = false;
			this.$toast.warning({
				message:'Not possible to delete this client',
				icon: "ti-alert",
			})
		}
    },
  },
  async beforeMount(){
	this.loading_client = true;
	await this.loadClient();
	this.loading_client = false;
  }
};
</script>
